import { getTimelineMetrics } from "./utils";

export const KIOSK_DIMENSIONS = {
  width: 3840,
  height: 2160,
};

export const MAP_POSITION = {
  center: { lat: 43.705016, lng: -72.2901953 },
  zoom: 17.06,
};

/** values of HEATMAP_SCALE.start are first color, HEATMAP_SCALE.end are last colors */
export const HEATMAP_SCALE = {
  start: 0,
  end: 400,
};

/** gradient for heatmap glow, from low values to high */
export const HEATMAP_COLORS = ["#00693E", "#AED773", "#FFA00F"];

/** interval to update all data, in minutes */
export const UPDATE_INTERVAL = 5;

/** interval to keep the qr code up before it auto disappears */
export const QR_TIMEOUT = 10;

/** number of questions in the gamification quiz */
export const QUIZ_LENGTH = 10;

/** Timeline styling properties based on window */
export const EVENT_WIDTH = getTimelineMetrics().eventWidth;
export const EVENT_GAP = getTimelineMetrics().eventGap;

/**
 * time in seconds for inactivity (INACTIVITY_TIME) and for timeout once
 * popup is displayed (RESET_TIME)
 */
export const RESET_TIME = 10;
export const INACTIVE_TIME = 300;
